import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import App from "./vue/App"; // Component gốc
import store from "./root.vuex"; // Vuex store
// import router from "./router"; // Vue Router
// import $ from "jquery"; 
import Notifications from '@kyvg/vue3-notification';
import Loader from "./../Loader.vue";

// Lấy ngôn ngữ từ <html lang="...">
const userLang = document.documentElement.lang || "vi";

// Load các file JSON từ /lang/
import vi from "./../../../lang/vi.json";
import en from "./../../../lang/en.json";

const messages = { vi, en };

const i18n = createI18n({
  legacy: false, // Cần đặt false để dùng với Vue 3 Composition API
  locale: userLang, // Ngôn ngữ mặc định từ trình duyệt hoặc thẻ <html>
  fallbackLocale: "vi", // Ngôn ngữ dự phòng nếu không tìm thấy
  messages, // Truyền messages vào i18n
	missingWarn: false, // Tắt cảnh báo khi thiếu key
  fallbackWarn: false, // Tắt cảnh báo fallback
});

// console.log("Debug i18n:", i18n.global.t("")); // Debug lỗi
// Tạo ứng dụng Vue
const app = createApp(App);
app.use(Notifications)
app.component('Loader', Loader);
// Gán jQuery vào global properties để sử dụng trong components
// app.config.globalProperties.$ = $;
app.use(i18n);
app.use(store);
// app.use(router);

// Gắn ứng dụng vào phần tử #app
app.mount("#app");
